// Components==============
import { useRecentActivities } from 'hooks/useRecentActivities';
import React, { createContext, useContext } from 'react';
import { GlobalEvidenceContext } from './GlobalEvidence';
// =========================

type GlobalRecentActivitiesContextType = RecentActivitiesResult;

export const GlobalRecentActivitiesContext = createContext(
  {} as GlobalRecentActivitiesContextType
);

export default function GlobalRecentActivities({
  children,
}: {
  children: React.ReactNode;
}) {
  const evidence = useContext(GlobalEvidenceContext);
  const recentActivities = useRecentActivities(evidence);

  return (
    <GlobalRecentActivitiesContext.Provider value={recentActivities}>
      {children}
    </GlobalRecentActivitiesContext.Provider>
  );
}
